import React, { Component } from 'react';
import { Link }             from 'react-router-dom';

import TimeAgo              from 'react-timeago';
import ruStrings            from 'react-timeago/lib/language-strings/ru'
import buildFormatter       from 'react-timeago/lib/formatters/buildFormatter'

import API                  from './server_api'

import './ProjectWithFolders.css';

const formatter = buildFormatter(ruStrings);

function Folder(props) {
    const empty = (props.files_num === 0);
    const icon = empty ? "img/folder-empty.svg" : "img/folder.svg";
    const animated = (props.animate===true) ? "folder-animated " : "";
    return (
        <div className={ animated + "list-group-item" } key={props.id}>
            <div className="d-flex w-100 justify-content-between">
                <div className="media">
                    <Link to={"/folder/"+props.id} className="align-self-center">
                        <img src={icon} className="mr-3" height="66" alt="folder" />
                    </Link>
                    <div className="media-body">
                        <Link to={"/folder/"+props.id} className='text-dark'>
                            <h4 className="mt-0 mb-0 text-break">{props.name}</h4>
                        </Link>
                        <small>
                        { empty ? 
                            <p className="mb-0 text-secondary">Нет файлов</p> :
                            <p className="mb-0 text-secondary">Файлов: {props.files_num}</p> 
                        } 
                        <p className="mb-0 text-secondary">
                            <TimeAgo date={props.updated} formatter={formatter} />
                        </p>
                        </small>
                    </div>
                </div>
                { empty && <button type="button" className="close" onClick={props.callback} id={props.id}>&times;</button> }
            </div>
        </div>
    );
}

function NewFolder(props) {
    return (
        <form className="form-inline mt-3" autoComplete="off" onSubmit={props.onAdd}>
            <label className="sr-only" htmlFor="folderName">Name</label>
            <input type="text" maxLength="50" className="form-control mb-2 mr-sm-2" id="folderName" 
                placeholder="Название папки" onChange={props.onEdit} value={props.text}/>
            { props.text.length >  0 ?
                <button type="submit" className="btn btn-primary btn-sm mb-2 mr-2">Создать</button> :
                <button type="submit" className="btn btn-primary btn-sm mb-2 mr-2" disabled>Создать</button>
            }
            <button className="btn btn-primary btn-sm mb-2" onClick={props.onCancel}>Отмена</button>
        </form>        
    );
}

function ProjectName(props) {
    return (
        <div>
            <div className="row mt-3">
                <div className="col-sm-8 mx-1">
                    <Link to={ '/project/' + props.id } className='text-dark mb-0'>
                        <h2> {props.name}</h2>
                    </Link>
                </div>
                <div className="col-sm mx-1 pt-sm-2 text-sm-right">
                    <small className="text-muted"><TimeAgo date={props.updated} formatter={formatter}/></small>
                </div>
            </div>
            <div className="row">
                <div className="col mx-1">
                    <p className="mb-0">{props.description}</p>
                </div>        
            </div>
            <div className="row">
                <div className="col mx-1">
                    { props.new_folder || <a href="/#" onClick={props.onClick}><small>Добавить папку »</small></a> }
                </div>        
            </div>
        </div>
    );
}


class ProjectWithFolders extends Component {
    constructor(props) {
        super(props);

        this.state              = props.project;
        this.state.new_folder   = false;
        this.state.new_folder_name = '';

        this.onNewFolder        = this.onNewFolder.bind(this);
        this.onCancel           = this.onButtonCancel.bind(this);
        this.onAdd              = this.onButtonAdd.bind(this);
        this.handleInputChange  = this.handleInputChange.bind(this);
        this.onButtonAdd        = this.onButtonAdd.bind(this);
        this.onButtonDelete     = this.onButtonDelete.bind(this);
        this.onButtonCancel     = this.onButtonCancel.bind(this);
        this.folderAdded        = this.folderAdded.bind(this);
        this.folderDeleted      = this.folderDeleted.bind(this);
    }

    onNewFolder(event){
        event.preventDefault();
        this.setState({ new_folder: true, new_folder_name: '' });
    }

    onButtonAdd(event){
        event.preventDefault();
        this.setState({ new_folder: false });
        API.addFolder(this.folderAdded, this.state.id, this.state.new_folder_name);
    }

    onButtonCancel(event){
        event.preventDefault();
        this.setState({ new_folder: false });
    }

    onButtonDelete(event){
        event.preventDefault();
        API.deleteFolder(this.folderDeleted, event.target.id);
    }

    folderAdded(folder){
        let folders = this.state.folders;
        // если создаем папку с дублирующимся имеем, сервер не создаст новую папку,
        // а вернет уже существующую с тем же именем. проверяем уникальность
        for (let i=0; i<folders.length; i++){
            folders[i].animate = false;
            if ( folders[i].id === folder.id ){
                // удаляем, чтобы затем добавить на вершину списка
                folders.splice(i,1);
                i--;
            }
        }
        // эту папочку нужно красиво появить на экране
        folder.animate = true;
        folders.unshift(folder);
        this.setState({ folders: folders });
    }

    folderDeleted(id){
        let folders = [];
        // сохраняем все, кроме удаленной папки
        for (let i in this.state.folders)
            if ( this.state.folders[i].id !== id )
                folders.push(this.state.folders[i]);
        this.setState({ folders: folders });
    }

    handleInputChange(event) {
        switch (event.target.id){
            case 'folderName':
                this.setState({ new_folder_name: event.target.value});
                break;
            default:
        }
    }    
 
    render() {
        // строим массив фолдеров
        const sorted = this.state.folders.sort( (a,b)=>{ return new Date(b.updated)-new Date(a.updated);} );
        const FoldersArray=[];
        for (let i in sorted ){
            // добавляем сслыку на колбэк
            let f = sorted[i];
            f.callback = this.onButtonDelete;
            FoldersArray.push(Folder(f));
        }
        // рендерим
        return (
            <div className="mb-4">
                <ProjectName 
                    id={this.state.id} 
                    name={this.state.name} 
                    updated={this.state.updated} 
                    onClick={this.onNewFolder} 
                    new_folder={this.state.new_folder}/>
                    
                { this.state.new_folder && <NewFolder 
                    onAdd={this.onButtonAdd} 
                    onCancel={this.onButtonCancel} 
                    onEdit={this.handleInputChange} 
                    text={this.state.new_folder_name}/> }

                <div className="list-group shadow mt-3">
                    {FoldersArray}
                </div>
            </div>
        );
    }
}

export default ProjectWithFolders;
